import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Stats.css';

class Stats extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    contents: PropTypes.arrayOf(
      PropTypes.shape({
        uniqueId: PropTypes.string.isRequired,
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        subText: PropTypes.string
      })
    ).isRequired
  };

  render() {
    const { contents } = this.props;
    return (
      <div className="statsBar">
        {contents.map(s => (
          <Stat key={s.uniqueId} subText={s.subText} title={s.title} statFooterComponent={s.cardFooterComponent} />
        ))}
      </div>
    );
  }
}

const Stat = ({ subText, title, statFooterComponent }) => {
  return (
    <div className="singleStat">
      <div className="title"> {title} </div>
      <div className="subText"> {subText} </div>
      <div className="subText"> {statFooterComponent}</div>
    </div>
  );
};

export default Stats;



// WEBPACK FOOTER //
// ./src/Components/Stats/Stats.js